function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-553.468 -2697.319)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M585.292,2704.454a2.018,2.018,0,1,1,2.019-2.016A2.02,2.02,0,0,1,585.292,2704.454Zm0-2.819a.8.8,0,1,0,.8.8A.8.8,0,0,0,585.292,2701.635Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M587.576,2709.431h-4.563a.61.61,0,0,1-.61-.61v-1.573a2.188,2.188,0,0,1,2.186-2.183H586a2.186,2.186,0,0,1,2.185,2.183v1.573A.609.609,0,0,1,587.576,2709.431Zm-3.954-1.216h3.345v-.967a.969.969,0,0,0-.968-.968h-1.41a.969.969,0,0,0-.967.968Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585.292,2732.017a3.448,3.448,0,1,1,3.455-3.447A3.454,3.454,0,0,1,585.292,2732.017Zm0-5.682a2.232,2.232,0,1,0,2.238,2.235A2.239,2.239,0,0,0,585.292,2726.335Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M589.9,2740.438H580.69a.609.609,0,0,1-.608-.61v-3.18a3.793,3.793,0,0,1,3.789-3.785h2.845a3.791,3.791,0,0,1,3.789,3.785v3.18A.609.609,0,0,1,589.9,2740.438Zm-8.6-1.217h7.991v-2.573a2.575,2.575,0,0,0-2.573-2.569h-2.845a2.576,2.576,0,0,0-2.573,2.569Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585.292,2747.767a.606.606,0,0,1-.3-.082l-12.52-7.22a.611.611,0,0,1-.3-.526v-14.451a.609.609,0,0,1,.3-.527l6.262-3.614,6.258-3.613a.616.616,0,0,1,.608,0l6.26,3.612,6.26,3.615a.61.61,0,0,1,.3.527v14.451a.611.611,0,0,1-.3.526l-12.519,7.22A.6.6,0,0,1,585.292,2747.767Zm-11.911-8.181,11.911,6.871,11.913-6.871V2725.84l-5.957-3.441-5.956-3.435-11.911,6.876Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585.292,2718.87a.608.608,0,0,1-.606-.608v-6.342a.609.609,0,0,1,1.217,0v6.342A.609.609,0,0,1,585.292,2718.87Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M597.946,2726.17a.607.607,0,0,1-.3-1.135l5.492-3.167a.609.609,0,0,1,.609,1.055l-5.494,3.167A.61.61,0,0,1,597.946,2726.17Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M603.439,2743.94a.6.6,0,0,1-.3-.082l-5.492-3.166a.609.609,0,1,1,.607-1.055l5.494,3.168a.609.609,0,0,1-.3,1.135Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585.292,2754.407a.606.606,0,0,1-.606-.606v-6.336a.609.609,0,1,1,1.217,0v6.336A.608.608,0,0,1,585.292,2754.407Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M567.147,2743.94a.608.608,0,0,1-.3-1.135l5.493-3.168a.609.609,0,0,1,.607,1.055l-5.494,3.166A.6.6,0,0,1,567.147,2743.94Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M572.639,2726.17a.6.6,0,0,1-.3-.08l-5.494-3.173a.608.608,0,1,1,.607-1.053l5.494,3.171a.61.61,0,0,1,.222.832A.6.6,0,0,1,572.639,2726.17Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585.292,2712.529a7.6,7.6,0,1,1,7.611-7.6A7.615,7.615,0,0,1,585.292,2712.529Zm0-13.994a6.39,6.39,0,1,0,6.4,6.393A6.4,6.4,0,0,0,585.292,2698.535Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M609.512,2726.5a7.643,7.643,0,0,1-6.6-3.8,7.612,7.612,0,0,1,6.584-11.416,7.646,7.646,0,0,1,6.6,3.808,7.612,7.612,0,0,1-6.587,11.408Zm-.015-14a6.394,6.394,0,1,0,5.548,3.2A6.4,6.4,0,0,0,609.5,2712.5Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M609.5,2754.438a7.6,7.6,0,1,1,6.6-3.8A7.614,7.614,0,0,1,609.5,2754.438Zm.012-14a6.426,6.426,0,0,0-5.547,3.2,6.4,6.4,0,0,0,5.535,9.586,6.391,6.391,0,0,0,.012-12.782Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585.292,2768.407a7.608,7.608,0,1,1,7.611-7.607A7.618,7.618,0,0,1,585.292,2768.407Zm0-14a6.392,6.392,0,1,0,6.4,6.393A6.4,6.4,0,0,0,585.292,2754.407Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M561.084,2754.438a7.632,7.632,0,0,1-6.593-3.8,7.608,7.608,0,0,1,6.584-11.409,7.6,7.6,0,0,1,7.357,9.575,7.621,7.621,0,0,1-7.348,5.637Zm-.009-14a6.391,6.391,0,1,0,5.543,3.194A6.373,6.373,0,0,0,561.075,2740.441Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M561.074,2726.5a7.607,7.607,0,0,1-7.343-5.639,7.537,7.537,0,0,1,.76-5.769,7.609,7.609,0,1,1,6.583,11.408Zm.014-14a6.42,6.42,0,0,0-5.545,3.2,6.391,6.391,0,0,0,2.338,8.728,6.393,6.393,0,1,0,3.207-11.925Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M609.507,2718.42a2.015,2.015,0,1,1,2.016-2.02A2.022,2.022,0,0,1,609.507,2718.42Zm0-2.815a.8.8,0,1,0,.8.795A.8.8,0,0,0,609.507,2715.6Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M611.785,2723.4h-4.561a.61.61,0,0,1-.61-.607v-1.581a2.186,2.186,0,0,1,2.187-2.179h1.407a2.185,2.185,0,0,1,2.185,2.179v1.581A.608.608,0,0,1,611.785,2723.4Zm-3.953-1.216h3.345v-.972a.966.966,0,0,0-.969-.961H608.8a.966.966,0,0,0-.969.961Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M561.082,2746.361a2.018,2.018,0,1,1,2.016-2.017A2.019,2.019,0,0,1,561.082,2746.361Zm0-2.819a.8.8,0,1,0,.8.8A.8.8,0,0,0,561.082,2743.542Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563.362,2751.338H558.8a.609.609,0,0,1-.609-.609v-1.575a2.187,2.187,0,0,1,2.185-2.183h1.408a2.187,2.187,0,0,1,2.185,2.183v1.575A.609.609,0,0,1,563.362,2751.338Zm-3.952-1.217h3.343v-.967a.966.966,0,0,0-.968-.966h-1.408a.965.965,0,0,0-.967.966Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M609.507,2746.361a2.018,2.018,0,1,1,2.016-2.017A2.022,2.022,0,0,1,609.507,2746.361Zm0-2.819a.8.8,0,1,0,.8.8A.8.8,0,0,0,609.507,2743.542Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M611.788,2751.338h-4.564a.61.61,0,0,1-.61-.609v-1.575a2.188,2.188,0,0,1,2.187-2.183h1.409a2.186,2.186,0,0,1,2.185,2.183v1.575A.608.608,0,0,1,611.788,2751.338Zm-3.956-1.217h3.348v-.967a.968.968,0,0,0-.97-.966H608.8a.967.967,0,0,0-.969.966Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M585.292,2760.328a2.016,2.016,0,1,1,2.019-2.014A2.019,2.019,0,0,1,585.292,2760.328Zm0-2.815a.8.8,0,1,0,.8.8A.8.8,0,0,0,585.292,2757.513Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M587.572,2765.309h-4.559a.61.61,0,0,1-.61-.609v-1.581a2.185,2.185,0,0,1,2.186-2.177H586a2.183,2.183,0,0,1,2.184,2.177v1.581A.61.61,0,0,1,587.572,2765.309Zm-3.95-1.217h3.343v-.973a.965.965,0,0,0-.968-.961h-1.408a.964.964,0,0,0-.967.961Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M561.08,2718.42a2.015,2.015,0,1,1,2.016-2.02A2.019,2.019,0,0,1,561.08,2718.42Zm0-2.815a.8.8,0,1,0,.8.795A.8.8,0,0,0,561.08,2715.6Z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563.362,2723.4H558.8a.608.608,0,0,1-.609-.607v-1.581a2.185,2.185,0,0,1,2.185-2.179h1.408a2.185,2.185,0,0,1,2.185,2.179v1.581A.608.608,0,0,1,563.362,2723.4Zm-3.952-1.216h3.343v-.972a.965.965,0,0,0-.968-.961h-1.408a.964.964,0,0,0-.967.961Z",
  fill: "#2d250c"
}));

var SvgPartner1 = function SvgPartner1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63.652,
    height: 71.088,
    viewBox: "0 0 63.652 71.088",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPartner1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/partner1.25161df1.svg";
export { ForwardRef as ReactComponent };